import { usePrice } from '../../utils/price';
import { carPath } from '../../cars/registry';
import type { CarProfile } from '../../cars/CarProfile';
import { navigate } from '../App';
import { PurchaseQR } from '../components/PurchaseQR';
import { RestoreButton } from '../components/RestoreButton';
import { getAccountEmail } from '../../utils/access';
import { useT } from '../../i18n';
import { useBuy } from '../useBuy';

/** Unlock — standalone purchase page for a car (also reachable from the demo popup). */
export function Unlock({ profile }: { profile: CarProfile }) {
  // No sign-up needed: Stripe asks for an email at checkout, that email becomes the account.
  const t = useT();
  const email = getAccountEmail();
  const buy = useBuy(profile.id, () => navigate(`/car/${carPath(profile)}`));
  return (
    <main class="unlock">
      <a class="back" href="/">← Roar<span>Drive</span></a>
      <div class="unlock__card">
        <div class="unlock__car">
          <span class="unlock__maker">{profile.manufacturer}</span>
          <span class="unlock__name">{profile.name}</span>
          <span class="unlock__engine">{profile.engineType}</span>
        </div>
        <div class="unlock__price">{t('oneTime', { price: usePrice() })}</div>
        {buy.canBuy
          ? <><button class="acctpanel__btn unlock__buy" disabled={buy.busy || buy.onSale === false} onClick={() => void buy.buy()}>{buy.onSale === false ? t('notInAppYet') : buy.busy ? buy.busyLabel : t('buyInApp', { price: buy.price || usePrice() })}</button>
              {buy.note && <div class="unlock__note">{buy.note}</div>}</>
          : <PurchaseQR profile={profile} size={260} onPaid={() => navigate(`/car/${carPath(profile)}`)} />}
        {/* already bought it? never make anyone pay twice — the restore is right under the price */}
        <RestoreButton variant="link" onDone={() => navigate(`/car/${carPath(profile)}`)} />
        {email ? (
          <div class="unlock__acct">{t('savedToAccount', { email })}</div>
        ) : (
          <div class="unlock__note">{t('unlockNote')}</div>
        )}
      </div>
    </main>
  );
}
